var jQuery = $;
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';
import para from '../../node_modules/jquery-parallax.js/parallax.min.js';
import fancy from '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';
const app = {
    /**
     * Initialize.
     */
    init() {

        // Smooth scroll to Anchor
        this.smoothAnchor();

        // Header scroll
        this.headerScrolled();

        // Register our event listeners
        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger, .navigation-overlay').on('click', $.proxy(this.toggleHamburgerMenu, this));
    },
    
    /** Handles the scroll event. */
    headerScrolled() {

        if($(window).scrollTop() > 0) {
            $('header').toggleClass('scrolled');
        }
    },

    windowScrollHandler() {
        $('header').toggleClass('scrolled', $(window).scrollTop() > 0);
    },
    
    /** Open hamburger menu. */
    toggleHamburgerMenu() {
        $(".hamburger").toggleClass('is-active');
        $("nav.navigation").toggleClass('visible');
        $(".navigation-overlay").toggleClass('is-active');
        $("body").toggleClass('is-locked');
    },

    /** Smooth scroll to Anchor */
    smoothAnchor() {
        $(document).on('click', 'main a[href^="#"]', function(e) {
            let id = $(this).attr('href');
            let $id = $(id);
            if ($id.length === 0) {
                return;
            }
            e.preventDefault();
            let pos = $id.offset().top - 60;
            $('body, html').animate({scrollTop: pos});
        });
    },
};

$(document).ready($.proxy(app.init, app));
